import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class DischargeSummaryNewService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private AddRecord = webapi + 'trn_discharge_summary_new/create';
    private AddEMGDischargeSummary = webapi + 'trn_discharge_summary_new/createEMGDischargeSummary';
    private ListbyRecord = webapi + 'trn_discharge_summary_new/admissionbyid/';
    private ListbyRecordVisit = webapi + 'trn_discharge_summary_new/visitbyid/';
    private GetRecordByAdmissionIdDsfIdFieldId = webapi + 'trn_discharge_summary_new/admissionbyiddsfidfieldid/';
    private GetRecordByVisitIdDsfIdFieldId = webapi + 'trn_discharge_summary_new/visitbyiddsfidfieldid/';
    private GetHistoryByAdmissionId = webapi + 'trn_discharge_summary_new/historybyadmissionId';
    private GetHistoryByVisitId = webapi + 'trn_discharge_summary_new/historybyvisitId';

    constructor(
        private http: Http
    ) {
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordEMGDischargeSummaryService(model: any) {
        return this.http.post(this.AddEMGDischargeSummary, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getrecordservice(id: any) {
        return this.http.get(this.ListbyRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    loadDropdown(url: any) {
        return this.http.get(webapi + url)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getrecordservicevisit(id: any) {
        return this.http.get(this.ListbyRecordVisit + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getHistoryservice(model: any) {
        return this.http.post(this.GetHistoryByAdmissionId, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getHistoryservicevisit(model: any) {
        return this.http.post(this.GetHistoryByVisitId, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getByAdmissionIdDsfIdFieldId(admissionId: any, dsfId: any, fieldId: any) {
        return this.http.get(this.GetRecordByAdmissionIdDsfIdFieldId + admissionId + '/' + dsfId + '/' + fieldId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getByVisitIdDsfIdFieldId(visitId: any, dsfId: any, fieldId: any) {
        return this.http.get(this.GetRecordByVisitIdDsfIdFieldId + visitId + '/' + dsfId + '/' + fieldId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ipd/discharge-summary-new/discharge-summary-new.service.ts